import { Injectable } from '@angular/core';

import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ZzzConfigService {
  private appConfig: any;
  protected initSubject = new ReplaySubject<any>();

  init(config: any) {
    this.appConfig = config;
    this.initSubject.next(this.appConfig);
    this.initSubject.complete();
  }

  onInit(): Observable<any> {
    return this.initSubject;
  }

  get(): any {
    return this.appConfig;
  }
}
